/* =========================================================
   VUJA DE — Archive Auto Load All（本番版・Read Moreタップ追記対応）
   /pages/archive で動作。
   - PC：Promise.all で並列fetch
   - モバイル：IntersectionObserver で逐次fetch
   - Read More：タップで次ページを既存商品の下に追記（ページ遷移しない）
   ========================================================= */

(function () {
  if (!window.location.pathname.match(/^\/pages\/archive\/?$/)) return;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 0);
  }

  function init() {
    attachReadMoreHandler();

    var marker = document.querySelector('.archive-load-more');
    if (!marker) return;
    var totalPages = parseInt(marker.dataset.totalPages, 10);
    if (!totalPages || totalPages <= 1) return;
    var gridContainer = marker.parentElement;
    if (!gridContainer) return;

    if (isMobileDevice()) {
      runMobileFlow(gridContainer, totalPages, marker);
    } else {
      runDesktopFlow(gridContainer, totalPages);
    }
  }

  function isMobileDevice() {
    if (navigator.userAgentData && typeof navigator.userAgentData.mobile === 'boolean') {
      return navigator.userAgentData.mobile;
    }
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(navigator.userAgent);
  }

  function hidePaginationContainer() {
    var pag = document.querySelector('.archive-fallback-pagination');
    if (pag) pag.style.display = 'none';
  }

  function updateReadMoreLink(html) {
    var existing = document.querySelector('.archive-read-more');
    if (!existing) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newRm = doc.querySelector('.archive-read-more');
    if (newRm && newRm.getAttribute('href')) {
      existing.setAttribute('href', newRm.getAttribute('href'));
    } else {
      hidePaginationContainer();
    }
  }

  function attachReadMoreHandler() {
    var link = document.querySelector('.archive-read-more');
    if (!link) return;
    link.addEventListener('click', onReadMoreClick);
  }

  function onReadMoreClick(e) {
    var link = e.currentTarget;
    if (link.dataset.loading === 'true') { e.preventDefault(); return; }

    var url = link.getAttribute('href');
    if (!url) return;

    e.preventDefault();
    link.dataset.loading = 'true';
    var originalText = link.textContent;
    link.textContent = 'Loading...';

    fetch(url, {
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var products = doc.querySelectorAll('[id^="product-item-"]');
        if (products.length === 0) throw new Error('no products');

        var paginationContainer = link.closest('.archive-fallback-pagination');
        var gridContainer = paginationContainer ? paginationContainer.parentElement : null;
        if (!gridContainer) throw new Error('no grid');

        for (var i = 0; i < products.length; i++) {
          var clone = products[i].cloneNode(true);
          gridContainer.insertBefore(clone, paginationContainer);
        }

        var newRm = doc.querySelector('.archive-read-more');
        if (newRm && newRm.getAttribute('href')) {
          link.setAttribute('href', newRm.getAttribute('href'));
          link.textContent = originalText;
          link.dataset.loading = 'false';
        } else {
          paginationContainer.style.display = 'none';
        }
      })
      .catch(function () {
        link.dataset.loading = 'false';
        link.textContent = originalText;
        // 失敗時のフォールバック：通常のページ遷移
        window.location.href = url;
      });
  }

  function runDesktopFlow(gridContainer, totalPages) {
    var fetches = [];
    for (var page = 2; page <= totalPages; page++) {
      fetches.push(fetchPage(page));
    }
    Promise.all(fetches).then(function (results) {
      results.forEach(function (html) {
        if (html) appendProductsFromHTML(gridContainer, html);
      });
      var leftMarker = document.querySelector('.archive-load-more');
      if (leftMarker) leftMarker.remove();
      hidePaginationContainer();
    });
  }

  function runMobileFlow(gridContainer, totalPages, marker) {
    marker.removeAttribute('hidden');
    marker.style.cssText = 'display:block;height:1px;width:100%;margin:0;padding:0;opacity:0;pointer-events:none;';

    if (!('IntersectionObserver' in window)) {
      loadSequential(gridContainer, totalPages, 2);
      return;
    }

    var currentPage = 2;
    var loading = false;
    var failures = 0;
    var MAX_FAILURES = 3;

    var observer = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      if (!entry.isIntersecting || loading) return;
      if (currentPage > totalPages) {
        observer.disconnect();
        marker.remove();
        hidePaginationContainer();
        return;
      }
      loading = true;
      var pageToFetch = currentPage;

      fetchPage(pageToFetch).then(function (html) {
        loading = false;
        if (!html) {
          failures++;
          if (failures >= MAX_FAILURES) { observer.disconnect(); marker.remove(); }
          return;
        }
        var added = appendProductsFromHTML(gridContainer, html);
        if (added === 0) {
          failures++;
          if (failures >= MAX_FAILURES) { observer.disconnect(); marker.remove(); return; }
          return;
        }
        updateReadMoreLink(html);
        currentPage++;
        if (currentPage > totalPages) {
          observer.disconnect();
          marker.remove();
          hidePaginationContainer();
        }
      }).catch(function () {
        loading = false;
        failures++;
        if (failures >= MAX_FAILURES) { observer.disconnect(); marker.remove(); }
      });
    }, { rootMargin: '500px' });

    observer.observe(marker);
  }

  function loadSequential(gridContainer, totalPages, page) {
    if (page > totalPages) {
      var leftMarker = document.querySelector('.archive-load-more');
      if (leftMarker) leftMarker.remove();
      hidePaginationContainer();
      return;
    }
    fetchPage(page).then(function (html) {
      if (html) {
        appendProductsFromHTML(gridContainer, html);
        updateReadMoreLink(html);
      }
      loadSequential(gridContainer, totalPages, page + 1);
    }).catch(function () {
      loadSequential(gridContainer, totalPages, page + 1);
    });
  }

  function fetchPage(page) {
    return fetch('/pages/archive?page=' + page, {
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html' }
    })
    .then(function (res) { return res.ok ? res.text() : null; })
    .catch(function () { return null; });
  }

  function appendProductsFromHTML(gridContainer, html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var products = doc.querySelectorAll('[id^="product-item-"]');
    if (products.length === 0) return 0;

    var localMarker = gridContainer.querySelector('.archive-load-more');
    var paginationContainer = gridContainer.querySelector('.archive-fallback-pagination');
    var beforeNode = localMarker || paginationContainer;
    var added = 0;
    for (var i = 0; i < products.length; i++) {
      var clone = products[i].cloneNode(true);
      if (beforeNode) {
        gridContainer.insertBefore(clone, beforeNode);
      } else {
        gridContainer.appendChild(clone);
      }
      added++;
    }
    return added;
  }
})();